// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3uEhh","ranges":"BmiRanges_ranges__1qaG-"};